export default [
  {
    to: "/projects/list",
    icon: "donut_small",
    name: "My Projects",
    enabled: true,
  },
];
